/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VolumeVo } from './VolumeVo';
import {
    VolumeVoFromJSON,
    VolumeVoFromJSONTyped,
    VolumeVoToJSON,
    VolumeVoToJSONTyped,
} from './VolumeVo';
import type { FeeVo } from './FeeVo';
import {
    FeeVoFromJSON,
    FeeVoFromJSONTyped,
    FeeVoToJSON,
    FeeVoToJSONTyped,
} from './FeeVo';

/**
 * 
 * @export
 * @interface GoodsPackingHistoryVo
 */
export interface GoodsPackingHistoryVo {
    /**
     * 
     * @type {VolumeVo}
     * @memberof GoodsPackingHistoryVo
     */
    volume?: VolumeVo;
    /**
     * 最近完成订单的完整费用明细；同类型多条不合并
     * @type {Array<FeeVo>}
     * @memberof GoodsPackingHistoryVo
     */
    fees?: Array<FeeVo>;
    /**
     * 体积保存时间
     * @type {string}
     * @memberof GoodsPackingHistoryVo
     */
    volumeUpdatedAt?: string;
    /**
     * 费用保存时间
     * @type {string}
     * @memberof GoodsPackingHistoryVo
     */
    feeUpdatedAt?: string;
    /**
     * 体积来源订单ID
     * @type {number}
     * @memberof GoodsPackingHistoryVo
     */
    volumeOrderId?: number;
    /**
     * 费用来源订单ID
     * @type {number}
     * @memberof GoodsPackingHistoryVo
     */
    feeOrderId?: number;
    /**
     * 体积来源订单编号
     * @type {string}
     * @memberof GoodsPackingHistoryVo
     */
    volumeOrderCode?: string;
    /**
     * 费用来源完成订单编号
     * @type {string}
     * @memberof GoodsPackingHistoryVo
     */
    feeOrderCode?: string;
}

/**
 * Check if a given object implements the GoodsPackingHistoryVo interface.
 */
export function instanceOfGoodsPackingHistoryVo(value: object): value is GoodsPackingHistoryVo {
    return true;
}

export function GoodsPackingHistoryVoFromJSON(json: any): GoodsPackingHistoryVo {
    return GoodsPackingHistoryVoFromJSONTyped(json, false);
}

export function GoodsPackingHistoryVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoodsPackingHistoryVo {
    if (json == null) {
        return json;
    }
    return {
        
        'volume': json['volume'] == null ? undefined : VolumeVoFromJSON(json['volume']),
        'fees': json['fees'] == null ? undefined : ((json['fees'] as Array<any>).map(FeeVoFromJSON)),
        'volumeUpdatedAt': json['volumeUpdatedAt'] == null ? undefined : json['volumeUpdatedAt'],
        'feeUpdatedAt': json['feeUpdatedAt'] == null ? undefined : json['feeUpdatedAt'],
        'volumeOrderId': json['volumeOrderId'] == null ? undefined : json['volumeOrderId'],
        'feeOrderId': json['feeOrderId'] == null ? undefined : json['feeOrderId'],
        'volumeOrderCode': json['volumeOrderCode'] == null ? undefined : json['volumeOrderCode'],
        'feeOrderCode': json['feeOrderCode'] == null ? undefined : json['feeOrderCode'],
    };
}

export function GoodsPackingHistoryVoToJSON(json: any): GoodsPackingHistoryVo {
    return GoodsPackingHistoryVoToJSONTyped(json, false);
}

export function GoodsPackingHistoryVoToJSONTyped(value?: GoodsPackingHistoryVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'volume': VolumeVoToJSON(value['volume']),
        'fees': value['fees'] == null ? undefined : ((value['fees'] as Array<any>).map(FeeVoToJSON)),
        'volumeUpdatedAt': value['volumeUpdatedAt'],
        'feeUpdatedAt': value['feeUpdatedAt'],
        'volumeOrderId': value['volumeOrderId'],
        'feeOrderId': value['feeOrderId'],
        'volumeOrderCode': value['volumeOrderCode'],
        'feeOrderCode': value['feeOrderCode'],
    };
}

